<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <div class="col-sm-6">
                <h4 class="card-title">Lista de Usuários</h4>
              </div>
              <div class="col-sm-6">
                <div class="text-sm-end">
                  <router-link to="/admin/users/create" class="btn btn-success float-right">
                    <i class="ri-user-add-line"></i>
                  </router-link>
                </div>
              </div>
            </div>

            <!-- Filtros -->
            <div class="row mb-3">
              <div class="col-md-3">
                <select v-model="filters.role" class="form-select" @change="onFilterChange">
                  <option value="">Todos os tipos</option>
                  <option value="ADMIN">Administrador</option>
                  <option value="DOCTOR">Médico</option>
                  <option value="TECHNICIAN">Técnico</option>
                  <option value="PATIENT">Paciente</option>
                </select>
              </div>
              <div class="col-md-3">
                <select v-model="filters.is_active" class="form-select" @change="onFilterChange">
                  <option value="">Todos os status</option>
                  <option value="true">Ativos</option>
                  <option value="false">Inativos</option>
                </select>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="users-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="users-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Buscar:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>

            <div v-if="loading" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
              </div>
            </div>

            <div v-else class="table-responsive">
              <b-table
                :items="users"
                :fields="fields"
                responsive="sm"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(name)="row">
                  {{ row.value || 'N/A' }}
                </template>

                <template v-slot:cell(role)="row">
                  <span class="badge bg-soft-primary text-primary">{{ getRoleLabel(row.value) }}</span>
                </template>

                <template v-slot:cell(is_active)="row">
                  <span 
                    :class="row.value ? 'badge bg-soft-success text-success' : 'badge bg-soft-danger text-danger'"
                  >
                    {{ row.value ? 'Ativo' : 'Inativo' }}
                  </span>
                </template>

                <template v-slot:cell(is_superuser)="row">
                  <i 
                    :class="row.value ? 'bx bx-check text-success' : 'bx bx-x text-muted'"
                  ></i>
                </template>

                <template v-slot:cell(created_at)="row">
                  {{ formatDate(row.value) }}
                </template>

                <template v-slot:cell(action)="row">
                  <a
                    href="javascript:void(0);"
                    class="mr-3 text-primary"
                    v-b-tooltip.hover
                    title="Editar"
                    @click="editUser(row.item)"
                  >
                    <i class="mdi mdi-pencil font-size-18"></i>
                  </a>                  
                  <a 
                    href="javascript:void(0);" 
                    :class="row.item.is_active ? 'text-warning' : 'text-success'" 
                    v-b-tooltip.hover 
                    :title="row.item.is_active ? 'Inativar usuário' : 'Ativar usuário'"
                    @click="confirmToggleStatus(row.item)"
                  >
                    <i :class="row.item.is_active ? 'mdi mdi-account-off font-size-18' : 'mdi mdi-account-check font-size-18'"></i>
                  </a>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { adminService } from "@/api/admin";

export default {
  page: {
    title: "Lista de Usuários",
    meta: [{ name: "description", content: "Lista de usuários do sistema" }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Lista de Usuários",
      items: [
        {
          text: "Administração",
          href: "/admin",
        },
        {
          text: "Usuários",
          active: true,
        },
      ],
      users: [],
      loading: false,
      filters: {
        role: "",
        is_active: "",
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        { key: "name", sortable: true, label: "Nome" },
        { key: "email", sortable: true, label: "Email" },
        { key: "role", sortable: true, label: "Tipo" },
        { key: "is_active", sortable: true, label: "Status" },
        { key: "is_superuser", sortable: true, label: "Super User" },
        { key: "created_at", sortable: true, label: "Criado em" },
        { key: "action", label: "Ações" }
      ]
    };
  },
  computed: {
    /**
     * Total no. of records (from API response)
     */
    rows() {
      return this.totalRows;
    }
  },
  async created() {
    await this.loadUsers();
  },
  watch: {
    // Watch for page changes
    currentPage() {
      this.loadUsers();
    },
    // Watch for perPage changes
    perPage() {
      this.currentPage = 1; // Reset to first page
      this.loadUsers();
    }
  },
  methods: {
    async loadUsers() {
      this.loading = true;
      try {
        // Preparar filtros convertendo strings para tipos corretos
        const params = {};
        
        // Parâmetros de paginação
        params.skip = (this.currentPage - 1) * this.perPage;
        params.limit = this.perPage;
        
        // Adicionar role se selecionado
        if (this.filters.role) {
          params.role = this.filters.role;
        }
        
        // Converter is_active string para boolean
        if (this.filters.is_active !== "") {
          params.is_active = this.filters.is_active === "true";
        }
        
        const response = await adminService.listUsers(params);
        
        // A resposta da API é diretamente um array de usuários
        if (Array.isArray(response)) {
          this.users = response;
          // Para paginação API, assumir que retornou até o limite
          this.totalRows = response.length === this.perPage ? 
            (this.currentPage * this.perPage) + 1 : 
            ((this.currentPage - 1) * this.perPage) + response.length;
        } else if (response.data && Array.isArray(response.data)) {
          this.users = response.data;
          this.totalRows = response.total || response.data.length;
        } else {
          console.error("Resposta da API inválida:", response);
          this.users = [];
          this.totalRows = 0;
        }
        
      } catch (error) {
        console.error("Erro ao carregar usuários:", error);
        this.$handleApiError(error);
        this.users = [];
        this.totalRows = 0;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Para busca local, ajustar o total de linhas
      // Mas como agora usamos paginação da API, isso pode não ser necessário
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    /**
     * Handle filter changes - reset to first page and reload
     */
    onFilterChange() {
      this.currentPage = 1;
      this.loadUsers();
    },

    getRoleLabel(role) {
      const labels = {
        ADMIN: "Administrador",
        DOCTOR: "Médico", 
        TECHNICIAN: "Técnico",
        PATIENT: "Paciente",
      };
      return labels[role] || role;
    },

    formatDate(dateString) {
      if (!dateString) return 'N/A';
      return new Date(dateString).toLocaleDateString('pt-BR');
    },

    editUser(user) {
      this.$router.push(`/admin/users/${user.id}/edit`);
    },

    confirmToggleStatus(user) {
      const action = user.is_active ? 'inativar' : 'ativar';
      const message = `Tem certeza que deseja ${action} o usuário ${user.email}?`;
      
      if (confirm(message)) {
        this.toggleUserStatus(user.id);
      }
    },

    confirmResetPassword(user) {
      const message = `Tem certeza que deseja gerar uma nova senha temporária para ${user.email}?`;
      
      if (confirm(message)) {
        this.resetUserPassword(user.id);
      }
    },

    async resetUserPassword(userId) {
      try {
        const response = await adminService.resetUserPassword(userId);
        
        if (response.temporary_password) {
          this.$showSuccess(
            `Senha temporária gerada: ${response.temporary_password}\nComunique esta senha ao usuário.`,
            { 
              variant: 'warning',
              autoHideDelay: 15000
            }
          );
        } else {
          this.$showSuccess("Senha temporária gerada com sucesso!");
        }
        
      } catch (error) {
        console.error("Erro ao resetar senha:", error);
        this.$handleApiError(error);
      }
    },

    async toggleUserStatus(userId) {
      try {
        // Encontrar o usuário para determinar a ação
        const user = this.users.find(u => u.id === userId);
        if (!user) {
          this.$showError('Usuário não encontrado');
          return;
        }
        
        // Chamar o endpoint apropriado baseado no status atual
        if (user.is_active) {
          await adminService.deactivateUser(userId);
        } else {
          await adminService.activateUser(userId);
        }
        
        // Atualizar o status localmente
        const userIndex = this.users.findIndex(u => u.id === userId);
        if (userIndex !== -1) {
          this.users[userIndex].is_active = !this.users[userIndex].is_active;
          const action = this.users[userIndex].is_active ? 'ativado' : 'inativado';
          this.$showSuccess(`Usuário ${action} com sucesso!`);
        }
        
      } catch (error) {
        console.error("Erro ao alterar status do usuário:", error);
        this.$handleApiError(error);
      }
    },
  },
};
</script>
